import { Box } from "@bca/ui-library";
import React from "react";
import styled from "styled-components";

const StyledBadge = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  color: white;
  border-radius: 8px;
  border: 2px solid #f8f9f8;
  margin-left: -8px;
  margin-bottom: -2px;
`;

interface SalvageDeclarationsBadgeProps {
  severityCode?: string;
}

const SalvageDeclarationsBadge: React.FunctionComponent<
  SalvageDeclarationsBadgeProps
> = ({ severityCode = "RED" }) => {
  const badgeVariant = {
    GREEN: {
      minWidth: "9px",
      height: "9px",
      background: "#00C546",
      padding: "0px",
    },
    AMBER: {
      minWidth: "16px",
      height: "16px",
      background: "#EE9504",
      padding: "0px",
    },
    RED: {
      minWidth: "16px",
      height: "16px",
      background: "#e30613",
      padding: "0px",
    },
  };

  return (
    <StyledBadge
      minWidth={badgeVariant[severityCode].minWidth}
      height={badgeVariant[severityCode].height}
      backgroundColor={badgeVariant[severityCode].background}
      padding={badgeVariant[severityCode].padding}
    >
      !
    </StyledBadge>
  );
};

export default SalvageDeclarationsBadge;
